import { User, UserVerifiedStatus } from '~core/models/auth.models';
import { isBitMaskFlagSet } from './utils';

export const addUserVerifiedProperties = (user: User): User => {
  return {
    ...user,
    emailVerified: isBitMaskFlagSet(
      user.propertiesVerified,
      UserVerifiedStatus.email
    ),
    phoneNumberVerified: isBitMaskFlagSet(
      user.propertiesVerified,
      UserVerifiedStatus.phoneNumber
    )
  };
};
